export default __webpack_public_path__ + "static/logo-alt-32186b234b0d2a6ebdf33c5e0921fde7.svg";